import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Form, FormGroup, Input, Label } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import HeaderCard from "../../../../Common/Component/HeaderCard";
import CloseModal from "../../../../../Constant/CloseModal";
import { CreateAppointment, DoctorList, NextAppointment, RescheduleAppointment } from "../../../../../apiController";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import SweetAlert from 'sweetalert2';

const BookingModal = ({ toggle, rows, edit }) => {
  const [doctordata, setData] = useState([]);
  const location = useLocation()

  const {data} = location.state || {};

  console.log(data)
  console.warn(rows)
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  // Fetch doctor list
  const fetchDoctorList = async () => {
    try {
      const response = await DoctorList();
      if (response.status === true) {
        const filteredList = await response.data;
        setData(filteredList);
      } else {
        console.error("Failed to fetch doctor list");
      }
    } catch (error) {
      console.error("Error fetching doctor list:", error);
    }
  };

  useEffect(() => {
    console.log(edit)
    fetchDoctorList();

    if (edit && data) {
      // Pre-fill form fields if edit is true
      setValue("date", edit.appointment_date);
      setValue("time", edit.appointment_time);
      setValue("doctor", edit.doctor_id);
    }
  }, [edit]);

  const handleResponse = async (apiCall, successMessage) => {
    try {
      const response = await apiCall();
      if (response.status === true) {
        toast.success(successMessage, {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        throw new Error("Request failed.");
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      toggle();
      // setLarge(!Large); // Uncomment if needed
    }
  };
  
  const onSubmit = async (formData) => {
    const { doctor, date, time } = formData;
  
    const baseData = {
      "patient_id": data.id,
      "doctor_id": doctor,
      "appointment_date": date,
      "appointment_time": time
    };
  
    if (edit) {
      const formattedData = {
        ...baseData,
        "treatment_id": edit.treatment_id,
        "service_id": edit.service_id,
        "id": edit.id
      };
  
      if (edit.appointment_status === 'Inprogress') {
        await handleResponse(() => NextAppointment(formattedData), "Appointment updated successfully!");
      } else {
        await handleResponse(() => RescheduleAppointment(formattedData), "Appointment rescheduled successfully!");
      }
    } else {
      const formattedData = {
        ...baseData,
        "treatment_id": rows.treatment_id,
        "service_id": rows.id
      };
  
      await handleResponse(() => CreateAppointment(formattedData), "Appointment created successfully!");
    }
  };
  
  

  return (
    <>
      <div className="login-main">
        <Form className="theme-form login-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex justify-content-between align-items-center">
            <HeaderCard title={edit? "Reschedule an Appoinment" :"Book an Appointment"} />
            <div className="" style={{ cursor: "pointer" }} onClick={toggle}>
              {/* <CloseModal /> */}
            </div>
          </div>
          <FormGroup>
            <Label className="col-form-label m-0 pt-0">Date</Label>
            <Controller
              name="date"
              control={control}
              rules={{ required: "Date is required" }}
              render={({ field }) => (
                <Input
                  className="form-control"
                  type="date"
                  placeholder="select appointment date"
                  {...field}
                />
              )}
            />
            {errors.date && <p className="text-danger">{errors.date.message}</p>}
          </FormGroup>
          <FormGroup className="mb-3">
            <Label htmlFor="doctor">Doctor</Label>
            <Controller
              name="doctor"
              control={control}
              rules={{ required: "Doctor selection is required" }}
              render={({ field }) => (
                <Input
                  type="select"
                  id="doctor"
                  {...field}
                >
                  <option value="">Select Doctor</option>
                  {doctordata.map((doc) => (
                    <option key={doc.id} value={doc.id}>
                      {doc.first_name}
                    </option>
                  ))}
                </Input>
              )}
            />
            {errors.doctor && <p className="text-danger">{errors.doctor.message}</p>}
          </FormGroup>
          <FormGroup>
            <Label className="col-form-label m-0 pt-0">Time</Label>
            <Controller
              name="time"
              control={control}
              rules={{ required: "Time is required" }}
              render={({ field }) => (
                <Input
                  className="form-control"
                  type="time"
                  placeholder="select appointment time"
                  {...field}
                />
              )}
            />
            {errors.time && <p className="text-danger">{errors.time.message}</p>}
          </FormGroup>
          <FormGroup>
            <Btn attrBtn={{ className: 'd-block w-100', color: 'primary', type: 'submit' }}>
              Confirm
            </Btn>
          </FormGroup>
        </Form>
      </div>
    </>
  );
};

export default BookingModal;